import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';
import actions from './actions';

const Layout = model.views(views).actions(actions);

export interface ILayout extends Instance<typeof Layout> {}

export default Layout;
